import Api from './api';

export default {
  async getOnboardingStatus() {
    const response = await Api.get('/v1/onboarding');
    return response.data;
  },

  async updateVideoAnalysisChecked(checked) {
    const response = await Api.patch('/v1/onboarding/video-analysis-checked', {
      videoAnalysisChecked: checked,
    });
    return response.data;
  },

  async updateDashboardOpened(opened) {
    const response = await Api.patch('/v1/onboarding/dashboard-opened', {
      dashboardOpened: opened,
    });
    return response.data;
  },

  async updateProgramOpened(opened) {
    const response = await Api.patch('/v1/onboarding/program-opened', {
      programOpened: opened,
    });
    return response.data;
  },
};
